import React, { useState, useEffect } from 'react';
import TopProspectsEvolutionChart from './charts/TopProspectsEvolutionChart';
import AverageScoreByFormationChart from './charts/AverageScoreByFormationChart';
import AlertsRecommendationsBlock from './alerts/AlertsRecommendationsBlock';
import { getAnalyticsData } from './dashboardAiService';

const AnalyticsSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedFormation, setSelectedFormation] = useState('all');
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchAnalytics = async () => {
    setLoading(true);
    setError(null);
    try {
      const json = await getAnalyticsData();
      setData(json);
      setLastUpdated(new Date().toLocaleTimeString('fr-FR'));
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAnalytics();
  }, []);

  if (loading) {
    return (
      <div className="analytics-section-container">
        <div className="analytics-loading">
          <div className="analytics-loading__spinner" />
          <span>Chargement des analyses IA...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="analytics-section-container">
        <div className="analytics-error">
          <span className="analytics-error__icon">⚠️</span>
          <span className="analytics-error__message">Erreur : {error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="analytics-section">
      <div className="analytics-grid">
        {/* Carte 1 — Évolution des prospects à fort potentiel */}
        <div className="analytics-card">
          <div className="analytics-card__header">
            <h3 className="analytics-card__title">
              <span>📈</span> Évolution des prospects à fort potentiel
            </h3>
          </div>
          <div className="analytics-card__body">
            {data?.topProspectsEvolution && (
              <TopProspectsEvolutionChart data={data.topProspectsEvolution} />
            )}
          </div>
        </div>

        {/* Carte 2 — Score moyen par formation */}
        <div className="analytics-card">
          <div className="analytics-card__header">
            <h3 className="analytics-card__title">
              <span>🎓</span> Score moyen par formation
            </h3>
            <div className="analytics-card__controls">
              <select
                className="analytics-card__filter"
                value={selectedFormation}
                onChange={(e) => setSelectedFormation(e.target.value)}
              >
                <option value="all">Toutes les formations</option>
                {data?.formations?.map((f) => (
                  <option key={f.id} value={f.id}>{f.intitule}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="analytics-card__body">
            <AverageScoreByFormationChart
              data={data?.scoreByFormation || []}
              selectedFormation={selectedFormation}
            />
          </div>
        </div>

        {/* Carte 3 — Alertes & Recommandations - PAS de style inline */}
        <div className="analytics-card">
          <div className="analytics-card__header">
            <h3 className="analytics-card__title">
              <span>🔔</span> Alertes & Recommandations
            </h3>
          </div>
          <div className="analytics-card__body">
            <AlertsRecommendationsBlock 
              alerts={data?.alerts || []} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsSection;